import { render, staticRenderFns } from "./PageVideo.vue?vue&type=template&id=985a3424&scoped=true&"
import script from "./PageVideo.vue?vue&type=script&lang=js&"
export * from "./PageVideo.vue?vue&type=script&lang=js&"
import style0 from "./PageVideo.vue?vue&type=style&index=0&id=985a3424&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985a3424",
  null
  
)

export default component.exports